<template>
  <v-dialog v-model="visible" persistent max-width="290">
    <v-card>
      <v-card-title class="headline">
        <template v-if="title">{{ title }}</template>
      </v-card-title>

      <v-card-text v-html="message"></v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="blue darken-1" text @click="visible = false">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  data() {
    return {
      title: "",
      message: "",
      visible: false,
    };
  },
  created() {
    this.$root.$on("message-dialog", (message) => {
      this.title = message.title;
      this.message = message.message;
      this.visible = true;
    });
    this.$root.$on("server-error", (message) => {
      this.title = "Ошибка";
      this.message = message.message;
      this.visible = true;
    });
    this.$root.$on("server-success", (message) => {
      this.title = "";
      this.message = message.message;
      this.visible = true;
    });
  },
};
</script>
